
export const getCachedImageUrl = (contentfulUrl) => {
  if (!contentfulUrl) {
    return contentfulUrl;
  }

  // Return Contentful URLs directly
  // Service Worker will cache them automatically
  // No server proxy needed - pure browser-side caching
  
  // Ensure URL has protocol for proper caching
  if (contentfulUrl.startsWith('//')) {
    return `https:${contentfulUrl}`;
  }
  
  // If already has protocol or is a relative path, return as-is
  return contentfulUrl;
};

export const isContentfulImage = (url) => {
  return url && url.includes('ctfassets.net');
};